// @flow

import { stateType } from '../app/stateTypes';

declare var interfaceConfig: Object;

/**
 * Opens the desktop app.
 *
 * @param {Object} state - Object containing current redux state.
 * @returns {Promise<boolean>} - Resolves with true if the attempt to open the desktop app was successful and resolves
 * with false otherwise.
 */
export function _openDesktopApp(state: Object) { // eslint-disable-line no-unused-vars
    const desktopApp = state[stateType.mtApi].desktopapp;

    return Promise.resolve(desktopApp === 0 ? interfaceConfig.ENABLE_DESKTOP_DEEPLINK : !desktopApp ?? false);
}
